import { useCallback, useEffect, useState } from 'react';
import {
  Button,
  Container,
  Dialog,
  Divider,
  Grid,
  Paper,
  Stack,
  Typography,
  IconButton,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useForm, useWatch } from 'react-hook-form';
import { FormProvider, Table, TextField, SelectTag, Checkbox } from '../../../../../components';
import { dropdownFetch, getKeyPathValue, request, toast } from '../../../../../utils';
import { REFERRAL_TYPE, TEST_FOR, FONT_TYPE } from '../../../../../constants';
import { LisTestItemMasterHelpForm } from './LisTestItemMasterHelpForm';
import { LisTestItemRefrenceRangeForm } from './LisTestItemRefrenceRangeForm';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import axios from 'axios';
import { BASE_URL } from '../../../../../utils';

const TEST_ITEM_HEADER = [
  {
    header: 'Test Item Name ',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row.test_item_name}`}
        </span>
      );
    }
  },
  {
    header: 'Method Name',
    accessor: 'method_name'
  },
  {
    header: 'SMS Name  ',
    accessor: 'sms_name'
  },
  {
    header: 'Test For',
    accessor: 'test_for'
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

// const TEST_HEADER = [
//   {
//     header: 'Gender',
//     accessor: 'gender',
//     sx: { textTransform: 'capitalize' }
//   },
//   {
//     header: 'Type',
//     accessor: 'type'
//   },
//   {
//     header: 'Age From',
//     accessor: 'age_from'
//   },
//   {
//     header: 'Age To',
//     accessor: 'age_to'
//   },

//   {
//     header: 'Age From(In Days)',
//     accessor: 'age_from_in_days'
//   },
//   {
//     header: 'Age To(in Days)',
//     accessor: 'age_to_in_days'
//   },
//   {
//     header: 'Range From',
//     accessor: 'range_from'
//   },
//   {
//     header: 'Range To',
//     accessor: 'range_to'
//   },
//   {
//     header: 'CrFrom',
//     accessor: 'cric_range_from'
//   },
//   {
//     header: 'CrTo',
//     accessor: 'cric_range_to'
//   },
//   {
//     header: 'Refernce Range(Textual Representation)',
//     accessor: 'ref_range_in_text'
//   }
// ];

const DESCRIPTION_HEADER = [
  {
    header: 'Description',
    accessor: 'help_descript',
    sx: { textTransform: 'capitalize' }
  }
];

const initialtestitemDataObj = {
  data: [],
  loading: false
};
export const LisTestItemMaster = () => {
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [testitemdataObj, setTestitemObj] = useState(initialtestitemDataObj);
  const [selectedRecord, setSelectedRecord] = useState();
  const [specimendropdown, setSpecimendropdown] = useState([]);
  const [maingroupdropdown, setMaingroupDropdown] = useState([]);
  const [helpdescriptiondialog, setHelpdescriptiondialog] = useState(false);
  const [helpdescriptionlist, setHelpdescriptionlist] = useState([]);
  const [refrencedialog, setRefrencedialog] = useState(false);
  const [refrencelist, setRefrencelist] = useState([]);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [categoryDropdown,setCategoryDropdown] = useState([])
  const [input, setInput] = useState('');
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [originalData, setOriginalData] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        test_item_name: Yup.string().required('Test Name  Is Required ')
        // default_value: Yup.string().required('Default Value Is Required'),
        // test_for: Yup.string().required('Test For  Is Required '),
        // specimen: Yup.string().required('Specimen  Is Required ')
      })
    ),
    defaultValues: {
      refrence_range_value: {
        general_from: 0,
        general_to: 0,
        male_from: 0,
        male_to: 0,
        female_from: 0,
        female_to: 0,
        child_from: 0,
        child_to: 0
      },
      critical_range_value: {
        general_from: 0,
        general_to: 0,
        male_from: 0,
        male_to: 0,
        female_from: 0,
        female_to: 0,
        child_from: 0,
        child_to: 0,
        linear_from: 0,
        linear_to: 0
      }
    },
    mode: 'all'
  });
  const getspecimendropdown = useCallback(async () => {
    const data = await dropdownFetch('specimen');
    if (!selectedRecord) {
      const [defaultSponsor] = data.filter(({ status }) => status === 'default');
      setValue('specimen', defaultSponsor?._id);
    }
    setSpecimendropdown(data);
  }, []);

  const getcategorydropdown = useCallback(async () => {
    const data = await dropdownFetch('category');
    setCategoryDropdown(data);
  }, []);

  const getmaingroupdropdown = useCallback(async () => {
    const data = await dropdownFetch('test-main-group');
    if (!selectedRecord) {
      const [defaultSponsor] = data.filter(({ status }) => status === 'default');
      setValue('main_group', defaultSponsor?._id);
    }
    setMaingroupDropdown(data);
  }, []);

  useEffect(() => {
    getspecimendropdown();
    getmaingroupdropdown();
    getcategorydropdown()
  }, [getspecimendropdown, getmaingroupdropdown,getcategorydropdown]);

  const { handleSubmit, setValue, reset, control,watch } = methods;

  const isNumericRes = useWatch({
    control,
    name: 'is_numeric_res',
    defaultValue: false
  });

  useEffect(() => {
    if (!isNumericRes) {
      setValue('decimal_place', '');
    }
  }, [isNumericRes, setValue]);

  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, '', ['_id', '__v', 'status', 'createdAt', 'beds']);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const formSubmit = async (formValues) => {
    console.log(formValues,"HELLO FORMVALUES")
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const payload = {
      ...formValues,
      main_group: formValues.main_group,
      refrence_range: refrencelist.map((data) => ({
        gender: data.gender,
        type: data.type,
        age_from: data.age_from,
        age_to: data.age_to,
        age_from_to_days: data.age_from_to_days,
        range_from: data.range_from,
        range_to: data.range_to,
        cric_range_from: data.cric_range_from,
        cric_range_to: data.cric_range_to,
        ref_range_in_text: data.ref_range_in_text
      })),
      help_descript: helpdescriptionlist.map((data) => ({
        help_descript: data.help_descript
      }))
    };
    const response = await request(editFlag ? '/lis-test-item-update' : '/lis-test-item-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: payload
    });

    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} Test Item Master`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      reset();
      setRefrencelist([]);
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} Test Item Master`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/lis-test-item-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully Cancelled Test Item  master', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel Test Item  master', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/lis-test-item-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Test Item  master', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Test Item  master', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleAddHelpDescription = (data) => {
    const existingDetail = helpdescriptionlist.find(({ help_descript }) => help_descript === data.help_descript);
    if (existingDetail) {
      toast('Help Description already chosen', { variant: 'error' });
      return;
    }
    setHelpdescriptionlist([...helpdescriptionlist, data]);
    setHelpdescriptiondialog(false);
  };

  const handleAddRefrenceRange = (data) => {
    setRefrencelist([...refrencelist, data]);
    setRefrencedialog(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setTestitemObj({ loading: true });
    try {
      const response = await axios.get(`${BASE_URL}/lis-test-item/list?limit=${10}`);
      if (response?.data.success) {
        setTestitemObj({ loading: false, data: response.data.data });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setTestitemObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during fetching:', error);
      toast('Error in fetching data', { variant: 'error' });
      setTestitemObj({ loading: false, data: [] });
    }
  };

  useEffect(() => {
    handleTestItemSearch(input);
  }, [input]);

  const handleTestItemSearch = async () => {
    const lowercasedInput = input.toLowerCase().trim();
    
      try {
        const response = await request('/lis-test-item-list', {
          method: 'GET',
          query: { test_item_name: lowercasedInput }
        });
        if (response.success && response.data) {
          setTestitemObj({ loading: false, data: response.data });
        } else {
          toast('Error in fetching data', { variant: 'error' });
          setTestitemObj({ loading: false, data: [] });
        }
      } catch (error) {
        console.error('Error during search:', error);
        toast('Error during search', { variant: 'error' });
        setTestitemObj({ loading: false, data: [] });
      }

  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

 
  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                Item Master
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                  onClick={handleSubmit(formSubmit)}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction)}
                  onClick={handleQueryWindow}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '80%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Test Item</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8, border: currentAction ? '0.1px solid red' : '' }}
                      name="test_item_name"
                      menus={REFERRAL_TYPE}
                      placeholder="Enter Test Item Name"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Unit Name</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                      name="unit_name"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Method</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      name="method_name"
                      placeholder="Enter Method"
                      sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Def. Value</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="default_value"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontSize: '1.6rem', fontWeight: 700, fontSize: '1.4rem' }}>
                      Specimen
                    </Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                      name="specimen"
                      menus={specimendropdown.map((data) => ({ ...data, name: data.specimen_name }))}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontSize: '1.6rem', fontWeight: 700, fontSize: '1.4rem' }}>
                     Category
                    </Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                      name="category"
                      menus={categoryDropdown.map((data) => ({ ...data, name: data.category_name }))}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12} sx={{ mt: 1, boxShadow: '0px 2px 2px #0099ff' }}>
                  <Typography variant="h5" fontWeight="bold">
                    Refrence Range
                  </Typography>
                  <Divider />
                </Grid>
                <Grid item xs={3} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.5, fontWeight: 700, fontSize: '1.4rem' }}>General</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.4, border: currentAction ? '0.5px solid red' : '' }}
                      name="refrence_range_value.general_from"
                      type="number"
                      placeholder="From"
                    />

                    <TextField
                      sx={{ flex: 0.4, border: currentAction ? '0.5px solid red' : '' }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      type="number"
                      name="refrence_range_value.general_to"
                      placeholder="To"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={3} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  {' '}
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.5, fontWeight: 700, fontSize: '1.4rem' }}>Male</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.4 }}
                      name="refrence_range_value.male_from"
                      type="number"
                      placeholder="From"
                    />
                    <TextField
                      sx={{ flex: 0.4 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      type="number"
                      name="refrence_range_value.male_to"
                      placeholder="To"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={3} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.5, fontWeight: 700, fontSize: '1.4rem' }}>Female</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.4 }}
                      name="refrence_range_value.female_from"
                      type="number"
                      placeholder="From"
                    />

                    <TextField
                      sx={{ flex: 0.4 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      type="number"
                      name="refrence_range_value.female_to"
                      placeholder="To"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={3} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  {' '}
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.5, fontWeight: 700, fontSize: '1.4rem' }}>Child</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.4 }}
                      name="refrence_range_value.child_from"
                      type="number"
                      placeholder="From"
                    />
                    <TextField
                      sx={{ flex: 0.4 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      type="number"
                      name="refrence_range_value.child_to"
                      placeholder="To"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12} sx={{ mt: 1, boxShadow: '0px 2px 2px #0099ff' }}>
                  <Typography variant="h5" fontWeight="bold">
                    Critical Range
                  </Typography>
                  <Divider />
                </Grid>
                <Grid item xs={3} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.5, fontWeight: 700, fontSize: '1.4rem' }}>General</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.4 }}
                      name="critical_range_value.general_from"
                      type="number"
                      placeholder="From"
                    />

                    <TextField
                      sx={{ flex: 0.4 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      type="number"
                      name="critical_range_value.general_to"
                      placeholder="To"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Ref. Range In Text</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="ref_range_in_text"
                      type="number"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={3} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  {' '}
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.5, fontWeight: 700, fontSize: '1.4rem' }}>Male</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.4 }}
                      name="critical_range_value.male_from"
                      type="number"
                      placeholder="From"
                    />
                    <TextField
                      sx={{ flex: 0.4 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      type="number"
                      name="critical_range_value.male_to"
                      placeholder="To"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={3} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.5, fontWeight: 700, fontSize: '1.4rem' }}>Female</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.4 }}
                      name="critical_range_value.female_from"
                      type="number"
                      placeholder="From"
                    />

                    <TextField
                      sx={{ flex: 0.4 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      type="number"
                      name="critical_range_value.female_to"
                      placeholder="To"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.5, fontWeight: 700, fontSize: '1.4rem' }}>Linear Range</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.4 }}
                      name="critical_range_value.linear_from"
                      type="number"
                      placeholder="From"
                    />

                    <TextField
                      sx={{ flex: 0.4 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      type="number"
                      name="critical_range_value.linear_to"
                      placeholder="To"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={3} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  {' '}
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.5, fontWeight: 700, fontSize: '1.4rem' }}>Child</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.4 }}
                      name="critical_range_value.child_from"
                      type="number"
                      placeholder="From"
                    />
                    <TextField
                      sx={{ flex: 0.4 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      type="number"
                      name="critical_range_value.child_to"
                      placeholder="To"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  <Button
                    onClick={() => setHelpdescriptiondialog(true)}
                    variant="contained"
                    sx={{ width: '10%', justifyContent: 'space-between', marginLeft: '90%' }}
                    disabled={!['edit', 'new'].includes(currentAction) || loading}
                  >
                    Add Help
                  </Button>
                  <Table
                    containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                    data={helpdescriptionlist}
                    columns={DESCRIPTION_HEADER}
                    size="medium"
                    showDeleteAction={true}
                    onDeleteHandler={(id) => {
                      setHelpdescriptionlist(helpdescriptionlist.filter(({ _id }) => _id !== id));
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog open={helpdescriptiondialog} onClose={() => setHelpdescriptiondialog(false)} scroll="body" maxWidth="xl">
        <LisTestItemMasterHelpForm onClose={() => setHelpdescriptiondialog(false)} onAdd={handleAddHelpDescription} />
      </Dialog>
      <Dialog open={refrencedialog} onClose={() => setRefrencedialog(false)} scroll="body" maxWidth="xl">
        <LisTestItemRefrenceRangeForm onClose={() => setRefrencedialog(false)} onAdd={handleAddRefrenceRange} />
      </Dialog>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0.2}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Lis Test Item Master Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Test Item Names"
            variant="outlined"
            value={input}
            onChange={handleChange}
            InputProps={{
              style: {
                fontSize: '12px',
                fontWeight: 600
              }
            }}
          />
        </Stack>
        <Table
          sx={{ mt: 1 }}
          columns={TEST_ITEM_HEADER}
          data={(testitemdataObj && testitemdataObj.data) || []}
          loading={testitemdataObj.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
    </>
  );
};
